import PageError from 'src/components/shared/PageError/PageError'

export default function PageNotFound(): JSX.Element {
  return <PageError />
}
